export default __webpack_public_path__ + "static/media/login-background.c34bed33.jpg";